import * as React from 'react';
import { Button } from '@blueprintjs/core';

interface Props {
    rightIcon?: any;
    onClick: any;
    intent: any;
    text: string;
    giant?: boolean;
    disabled?: boolean;
    style?: React.CSSProperties;
};

interface State {}

export class LargeButton extends React.Component<Props, State> {

    state: State = {

    }

	render() {
        const {
            rightIcon,
            onClick,
            intent,
            text,
            disabled,
            giant,
            style
        } = this.props;

        if (giant === true) {
            return <Button disabled={disabled} style={{width: '100%', height: '40px', fontSize: '21px', ...style}} large rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
        }

        return <Button disabled={disabled} style={{width: '100%', ...style}} large rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
	}
}
